import { calculate } from '@moleculeone/draw';
import { SVGMol } from '@moleculeone/ui';
import { Mol } from '@moleculeone/types';

export function getDrawingRandomSeed(seedId: string) {
  const seed = parseInt(SVGMol.randomSeeds[seedId], 10);

  return Number.isFinite(seed) ? seed : 0;
}

export function incrementDrawingRandomSeed(seedId: string) {
  const seed = parseInt(SVGMol.randomSeeds[seedId], 10);
  const nextSeed = Number.isFinite(seed) ? seed + 1 : 1;

  SVGMol.randomSeeds[seedId] = String(nextSeed);

  return nextSeed;
}

export function calculateSeededPositions({
  mol,
  seedId,
  incrementSeed = false,
  ...restParams
}: {
  mol: Mol;
  seedId: string;
  incrementSeed?: boolean;
}) {
  let randomSeed: number;

  if (!incrementSeed) {
    randomSeed = getDrawingRandomSeed(seedId);
  } else {
    randomSeed = incrementDrawingRandomSeed(seedId);
  }

  return calculate(mol, {
    ...restParams,
    randomSeed,
  });
}
